export default {
  playRecording: 'Poner la Grabacion',
  stopPlayback: 'Parar la Repetición',
};
